import { render, staticRenderFns } from "./selection-header.vue?vue&type=template&id=e3611fc8"
import script from "./selection-header.vue?vue&type=script&lang=ts"
export * from "./selection-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports